export const STATUS_ID = 'resolvableServiceStatus';
